<template>
  <v-container>
    Redirecting....
    <!-- <div v-if="loading">Logging</div> -->
  </v-container>
</template>

<script>
export default {
  name: "LoginSuccess",
  data() {
    return {
      loading: false,
    };
  },
  // sample: http://localhost:8080/loginsuccess?authCode=fasdfadsfdsdf&userId=fdsaf545
  // http://localhost:8080/loginsuccess?authCode=OOS92G07CGBEDI466J0P&userId=759648
  // localhost:8080/loginsuccess?authCode=EJ645IPN8TZT7C86QMPG&userId=538405&appcode=oIEVWdKO5H1L0GT
  mounted() {
    this.login();
  },
  methods: {
    async login() {
      this.loading = true;
      console.log(this.$route)
      const auth_code = this.$route.query["user_id"];
      const user_id = this.$route.query["client_id"];
      const page = this.$route.query["page"];
      const ws_access_token = this.$route.query["ws_token"];
      const access_token = this.$route.query["access_token"];
      localStorage.removeItem("modalShownBefore");
      localStorage.removeItem("announcementModalShownBefore");
      if (page) {
        localStorage.setItem("redirectedPath", page);
      }
      await this.$store.dispatch("login", {
        auth_code: auth_code,
        user_id: user_id,
        ws_access_token: ws_access_token,
        access_token: access_token,
        broker: "aliceblue",
      });
      this.loading = false;
    },
  },
};
</script>
